// FIXME: Update this configuration file based on your project information

export const AppConfig = {
  site_name: process.env.NEXT_SEO_URL,
  title: process.env.NEXT_SEO_TITLE,
  description: process.env.NEXT_SEO_DESCRIPTION,
  locale: 'vi',
}
